"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppUrls = exports.GlobalAppUrls = void 0;
var GlobalAppUrls = /** @class */ (function () {
    function GlobalAppUrls() {
        this.Client = {
            Home: "/",
            Samples: "/samples",
            Error: "/error",
            NotFound: "/notfound",
            PrivacyPolicy: "/privacy-policy",
            Terms: "/terms",
            Test: "/test",
            Application: "/applicationform/:applicationId?",
            ThankYouForSubmitting: "/thankyouforsubmitting",
            Dashboard: "/dashboard",
            Account: {
                Login: "/login",
                Logout: "/logout",
                ForgotPassword: "/forgotpassword",
                ForgotPasswordSuccess: "/forgotpassword-success",
                ResetPassword: "/resetpassword",
                Register: "/register",
                SessionExpired: "/sessionexpired",
                Applicant: {
                    Register: "/applicantregister",
                },
            },
            Admin: {
                AdminManageUsers: "/admin",
                AdminHome: "/admin/applicants",
                LogViewer: "/admin/logviewer",
                Applicant: "/admin/applicant/:applicantId?",
            },
        };
        this.Server = {
            Account: {
                Login: "/api/account/login",
                Logout: "/api/account/logout",
                ResetPassword: {
                    Reset: "/api/account/resetpassword",
                    VerifyToken: "/api/account/resetpasswordtoken",
                },
                SetPassword: "/api/account/setpassword",
                ForgotPassword: "/api/account/forgotpassword",
                Register: "/api/account/register",
            },
            Dashboard: "/api/dashboard/getclientdashboard",
            ApplicationForm: {
                GetApplicationFormById: "/api/applicationform/getapplicationformbyid",
                GetApplicationFormAndRelatedById: "/api/applicationform/getapplicationformandrelatedbyid",
                GenerateApplicationFormPdfById: "/api/pdf/generateapplicationformpdfbyid",
                Upsert: {
                    Applicant: "/api/applicant/upsert",
                    Application: "/api/applicationform/upsert",
                    PersonalDetails: "/api/applicationform/upsertpersonaldetails",
                    PreviousAddress: "/api/applicationform/upsertpersonaldetailpreviousaddress",
                    FamilyAddress: "/api/applicationform/upsertpersonaldetailfamilyaddress",
                    EmploymentDetails: "/api/applicationform/upsertemploymentdetails",
                    ArmedForcesProof: "/api/applicationform/upsertemploymentdetailsarmedforcesproof",
                    AuditedAccount: "/api/applicationform/upsertemploymentdetailsauditedaccount",
                    IncomeDetails: "/api/applicationform/upsertincomedetails",
                    MoneyGifter: "/api/applicationform/upsertincomedetailsmoneygifter",
                    OutstandingLoan: "/api/applicationform/upsertincomedetailsoutstandingloan",
                    CreditCard: "/api/applicationform/upsertincomedetailscreditcard",
                    FinancialCommitment: "/api/applicationform/upsertincomedetailsfinancialcommitment",
                    StatementDetails: "/api/applicationform/upsertstatementdetail",
                    PropertyDetails: "/api/propertydetails/upsert",
                    Person: "/api/propertydetails/upsertperson",
                    CurrentPropertyDetails: "/api/currentpropertydetails/upsert",
                    NewPropertyDetails: "/api/newpropertydetails/upsert",
                    BackgroundInformation: "/api/backgroundinformation/upsert",
                    Declaration: "/api/declaration/upsert",
                    CreditReport: "/api/creditreport/upsert",
                    SupportingInformation: "/api/supportinginformation/upsert",
                    GetAllPayToken: "/api/paymentinformation/gettoken",
                    PaymentInformation: "/api/paymentinformation/upsert",
                },
            },
            SelectOptions: {
                Lender: "/api/selectoptions/getlendertypeoptions",
                Gender: "/api/selectoptions/getgenderoptions",
                Title: "/api/selectoptions/gettitleoptions",
                SharedOwnership: "/api/selectoptions/getsharedownershipoptions",
                EmploymentStatus: "/api/selectoptions/getemploymentstatusoptions",
            },
            File: {
                UploadFile: "/api/upload/uploadfile",
                DownloadFile: "/api/upload/downloadfile",
                UploadSignature: "/api/upload/uploadsignature",
            },
            Applicant: {
                RegisterApplicant: "/api/applicant/registerapplicant",
                VerifyToken: "/api/applicant/checkregistrationtoken",
                InsertAllPay: "/api/applicant/insertallpay",
            },
            Admin: {
                GetApplicantUser: "/api/applicant/GetApplicantUser",
                GetAllApplicantUsers: "/api/applicant/getallapplicantusers",
                SearchAllApplicantUsers: "/api/applicant/searchallapplicantusers",
                ResetFailedLoginAttemptsCount: "/api/user/ResetLoginAttempts",
                NewApplicantRequest: "/api/applicant/create",
                DeleteApplicantUser: "/api/applicant/DeleteApplicantUser",
                ResendRegistration: "/api/applicant/ResendRegistration",
                ApproveAmendReject: "/api/applicationform/ApproveAmendReject",
                UpdateApplicantStatus: "/api/applicant/updateapplicantstatus",
                UpdateApplicationSupportingInfo: "/api/applicationform/UpdateApplicationSupportingInfo",
                UpdateCanStartNewApplicationForm: "/api/applicant/updatecanstartnewapplicationform",
                UpdateApplicationStatus: "/api/applicationform/updateapplicationstatus",
                Upsert: {
                    Amendment: "/api/amendment/upsert",
                },
            },
        };
    }
    return GlobalAppUrls;
}());
exports.GlobalAppUrls = GlobalAppUrls;
exports.AppUrls = new GlobalAppUrls();
//# sourceMappingURL=AppUrls.js.map